/// <amd-module name="Likes/LikeStore" />
import { Store } from "VSS/Reflux/Store";

import { LikeActions, LikeInfoPayload, LikeState } from "Likes/ActionsHub";

export class LikeStore extends Store {
    private _state: LikeState;
    private _loading: boolean;

    constructor(private _actions: LikeActions, initialState?: LikeState) {
        super("likesChangedEvent");
        this._loading = true;
        if (initialState) {
            this._state = initialState;
        } else {
            this._state = {
                isLiked: false,
                likeCount: 0
            };
        }
        this._actions.likeInfoReceived.addListener(this._onLikeInfoReceived);
        this._actions.createLikeStarted.addListener(this._onCreateSocialEngagementStarted);
        this._actions.deleteLikeStarted.addListener(this._onDeleteSocialEngagementStarted);
        this._actions.likedUsersInfoReceived.addListener(this._onLikedUsersInfoReceived);
    }

    public getState(): LikeState {
        return this._state;
    }

    public isLoading(): boolean {
        return this._loading;
    }

    public dispose(): void {
        this._actions.likeInfoReceived.removeListener(this._onLikeInfoReceived);
        this._actions.createLikeStarted.removeListener(this._onCreateSocialEngagementStarted);
        this._actions.deleteLikeStarted.removeListener(this._onDeleteSocialEngagementStarted);
        this._actions.likedUsersInfoReceived.removeListener(this._onLikedUsersInfoReceived);
    }

    private _onLikeInfoReceived = (state: LikeInfoPayload): void => {
        if (this.isLoading()) {
            this._state = { ...state, topLikedUsers: this._state.topLikedUsers };
            this._loading = false;
            this.emitChanged();
        } else if (this._state.isLiked !== state.isLiked || this._state.likeCount !== state.likeCount) {
            this._state = { ...state, topLikedUsers: this._state.topLikedUsers };
            this.emitChanged();
        }
    };

    private _onCreateSocialEngagementStarted = (): void => {
        this._state.isLiked = true;
        this._state.likeCount = this.getState().likeCount + 1;
        this.emitChanged();
    };

    private _onDeleteSocialEngagementStarted = (): void => {
        this._state.isLiked = false;
        if (this.getState().likeCount > 0) {
            this._state.likeCount = this.getState().likeCount - 1;
        }
        this.emitChanged();
    };

    private _onLikedUsersInfoReceived = (users: string[]): void => {
        this._state.topLikedUsers = users;
        this.emitChanged();
    };
}
